/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Vraťte svou objednávku`
};

const da_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Returnér din ordre`
};

const de_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung zurückgeben`
};

const en_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Return your order`
};

const es_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Devuelve tu pedido`
};

const fr_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Retournez votre commande`
};

const hu_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelésed visszaküldése`
};

const it_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Restituisci il tuo ordine`
};

const nl_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Retourneer je bestelling`
};

const pl_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Zwróć zamówienie`
};

const pt_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Devolva seu pedido`
};

const sv_reinsurances_return_link_text = /** @type {(inputs: {}) => string} */ () => {
	return `Returnera din beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_return_link_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_return_link_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_return_link_text", locale)
	if (locale === "cs") return cs_reinsurances_return_link_text(inputs)
	if (locale === "da") return da_reinsurances_return_link_text(inputs)
	if (locale === "de") return de_reinsurances_return_link_text(inputs)
	if (locale === "en") return en_reinsurances_return_link_text(inputs)
	if (locale === "es") return es_reinsurances_return_link_text(inputs)
	if (locale === "fr") return fr_reinsurances_return_link_text(inputs)
	if (locale === "hu") return hu_reinsurances_return_link_text(inputs)
	if (locale === "it") return it_reinsurances_return_link_text(inputs)
	if (locale === "nl") return nl_reinsurances_return_link_text(inputs)
	if (locale === "pl") return pl_reinsurances_return_link_text(inputs)
	if (locale === "pt") return pt_reinsurances_return_link_text(inputs)
	return sv_reinsurances_return_link_text(inputs)
};
export { reinsurances_return_link_text as "reinsurances.return_link_text" }